import type { CSSObject } from 'styled-components';

/**
 * Shallow-merges token style blocks left-to-right. Nested selector keys
 * (`&:hover`, `&:focus`, …) are overwritten wholesale, not deep-merged — each
 * source must fully specify any nested selector it needs, since a later source
 * with the same key replaces the earlier one's entire block.
 */
export const mergeTokenStyles = (
  ...sources: (CSSObject | undefined)[]
): CSSObject =>
  sources.reduce<CSSObject>(
    (result, source) => (source ? { ...result, ...source } : result),
    {},
  );

const normalizeCompoundValue = (value: unknown): string | undefined => {
  if (typeof value === 'boolean') {
    return String(value);
  }
  return typeof value === 'string' ? value : undefined;
};

export const matchesTokenCompoundVariant = (
  compound: { [key: string]: unknown; styles: CSSObject },
  resolved: Record<string, string | boolean | undefined>,
): boolean =>
  Object.keys(compound)
    .filter((key) => key !== 'styles')
    .every(
      (key) =>
        normalizeCompoundValue(compound[key]) ===
        normalizeCompoundValue(resolved[key]),
    );
